<!--
 * @Description: 入库检验
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-16 10:13:06
-->
<template>
  <SpecialCheckout type="2" typeId="3" />
</template>

<script>
import SpecialCheckout from './component/specialCheckout'
export default {
  components: {
    SpecialCheckout
  },
};
</script>
